import React, { useContext } from 'react';
import { mensajeExito } from '../../generico/MensajeSistemaToast';
import history from "../login/history";
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { WizardContext } from '../../generico/CustomStepWizard';
import { formatoSeparadorMilesValue } from '../../generico/utils/FormatoInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DataTable from 'react-data-table-component';
import ConfigService from '../../../services/configuracion/ConfigService';

export const TrasladoCuotaPaso3 = (props) => {

    const trasladoCuotaContext = useContext(WizardContext);

    const { state } = trasladoCuotaContext;

    mensajeExito("Fecha de Vencimiento modificado Exitosamente");

    const returnToFirstStep = () =>{
        // resetState();
        // props.firstStep();
        history.push(ConfigService.getPathByName("resumenGeneralSocio")?.url);
        window.location.reload();
    }

    const getDatosComprobante = () => {
        const respuesta = [
            { concepto: "Pagaste con la cuenta: ", valor: `N°${state.credito.cuenta}` },
            { concepto: "N° de Crédito:", valor: state.credito.cuenta },
            { concepto: "Primera cuota activa:", valor: state.credito.cuotasPagadas + 1 },
            { concepto: "Fecha de Vencimiento anterior:", valor: state.credito.fechaVencimiento },
            { concepto: "Fecha de Vencimiento actual:", valor: state.fechaSeleccionada },
            { concepto: "Diferencia en días:", valor: state.diferenciaDias },
            { concepto: "Interés Pagado:", valor: formatoSeparadorMilesValue(state.interesAPagar) },
        ];
        return respuesta;
    }

    const getColumn = () => {
        return [
            {
                name: "concepto",
                selector: row => row.concepto,
            },
            {
                name: "valor",
                selector: row => row.valor,
            },
        ];
    }

    return (
        <>
            <div className="row justify-content-md-center">
                <div className="col-lg-7 col-md-10">
                    <p className="nro-operacion">
                        Número de Operación: {state?.responseCambioVencimiento?.idMovimiento | '123456789'}
                    </p>
                </div>
            </div>

            <div className="row" style={{marginTop:15,marginBottom:25}}>
                <div className="col-lg-12">
                    <div className="row justify-content-md-center">
                        <div className="col-lg-7 col-md-10">
                            <div className="row">
                                    <DataTable
                                        noHeader={true}
                                        columns={getColumn()}
                                        data={getDatosComprobante()}
                                        dense={true}
                                        noDataComponent="No hay registros para mostrar"
                                        responsive={true}
                                        noTableHead={true}
                                    />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr />

            <div className="row">
                <div className="col-lg-8 col-md-6"></div>
                <div className="col-lg-12 col-md-12">
                    <button
                        onClick={returnToFirstStep}
                        type="button"
                        className="btn btn-cu-primary btn-consulta"
                    >
                        <FontAwesomeIcon icon={faArrowLeft}/>  Ir al Inicio
                    </button>
                </div>
            </div>
        </>
    )
}
